import React from "react";

export default function ToolbarLine({ children }) {
  return (
    <div
      css={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        "& > div": {
          marginRight: "0.5rem",
        },
      }}
    >
      {children}
    </div>
  );
}
